export default {
  setFAQpage(state, data) {
    state.faqPage = data;
  },
  setFaq(state, data) {
    state.faq = data;
  },
};
